import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EyeEmptyIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EyeEmptyIcon = ({ className, ...props }: EyeEmptyIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99866 3.69434C10.7856 3.69434 12.5975 5.89863 13.9157 7.52832C14.1176 7.77808 14.1379 8.12882 13.9664 8.40039C13.3632 9.3557 12.5181 10.3184 11.5133 11.0488C10.5099 11.7782 9.30451 12.3057 7.99866 12.3057C6.69304 12.3055 5.48824 11.7781 4.48499 11.0488C3.48026 10.3184 2.63505 9.35561 2.03186 8.40039C1.86052 8.12882 1.88073 7.77801 2.08264 7.52832C3.4007 5.89878 5.21192 3.69467 7.99866 3.69434ZM7.99866 5.19434C6.19941 5.19464 4.89064 6.48812 3.60217 8.04199C4.08245 8.70433 4.68676 9.34153 5.36682 9.83594C6.19916 10.4409 7.1014 10.8055 7.99866 10.8057C8.89616 10.8057 9.79893 10.4411 10.6315 9.83594C11.3115 9.34159 11.9149 8.70427 12.3951 8.04199C11.1067 6.48817 9.79803 5.19434 7.99866 5.19434ZM7.99964 6.06445C9.06811 6.06467 9.93401 6.93153 9.93421 8C9.93401 9.06848 9.06811 9.93436 7.99964 9.93457C6.93098 9.93457 6.06428 9.06861 6.06409 8C6.06429 6.93139 6.93098 6.06445 7.99964 6.06445ZM7.99964 7.56445C7.75941 7.56445 7.56429 7.75982 7.56409 8C7.56428 8.24018 7.75941 8.43457 7.99964 8.43457C8.23968 8.43436 8.43401 8.24005 8.43421 8C8.43401 7.75995 8.23968 7.56466 7.99964 7.56445Z"
      fill="#3F3A3B"
    />
  </svg>
);

export default EyeEmptyIcon;
